"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.negativeAlt = exports.negativeExtra = exports.negative = void 0;
var negative = {
  50: '#FAE6E6',
  100: '#F2C1C1',
  200: '#E99797',
  300: '#E06D6D',
  400: '#DA4E4E',
  500: '#D32F2F',
  600: '#CE2A2A',
  700: '#C82323',
  800: '#C21D1D',
  900: '#B71212'
};
exports.negative = negative;
var negativeExtra = {
  light: '#FFF1F6'
};
exports.negativeExtra = negativeExtra;
var negativeAlt = {
  50: '#FCECE7',
  100: '#F7D1C2',
  200: '#F2B29A',
  300: '#ED9372',
  400: '#E97B53',
  500: '#E56435',
  600: '#E25C30',
  700: '#DE5228',
  800: '#DA4822',
  900: '#D33616'
};
exports.negativeAlt = negativeAlt;
//# sourceMappingURL=negative.js.map